import { MeetingLeftPage } from '@/components/templates/MeetingLeftPage/MeetingLeftPage'

export function PhoneMeetingLeftPage() {
  return <MeetingLeftPage meetingType="phone" />
}
